import { authClient, API } from "../index";

// Get all paises
export const getPaises = () => {
  return authClient().get(`${API}/pais`);
};

// Get pais by id
export const getPaisById = (id) => {
  return authClient().get(`${API}/pais/${id}`);
};
